import { OAuthScope } from './enums'

/** The option list's own shape, so it lives beside the list rather than in `interfaces/`. */
export interface OAuthScopeOption {
  value: OAuthScope
  label: string
  description: string
}

/**
 * Labels and plain-language descriptions from the approved prototype's `oauthScopes`
 * (apps/admin-prototype/public/apps/admin-dashboard.html). The Retool app showed the raw scope
 * strings; saying what each grant allows is the point of this tab's redesign.
 */
export const OAUTH_SCOPE_OPTIONS: OAuthScopeOption[] = [
  {
    value: OAuthScope.Contractor,
    label: 'Contractors',
    description: 'Read and manage this customer’s contractors (drivers).',
  },
  {
    value: OAuthScope.Template,
    label: 'Onboarding templates',
    description: 'Read the onboarding step templates for this customer.',
  },
  {
    value: OAuthScope.Market,
    label: 'Markets',
    description: 'Read this customer’s operating markets and regions.',
  },
  {
    value: OAuthScope.Webhook,
    label: 'Webhooks',
    description: 'Manage webhook subscriptions that notify this customer of events.',
  },
]

export const KNOWN_OAUTH_SCOPES: OAuthScope[] = OAUTH_SCOPE_OPTIONS.map((option) => {
  return option.value
})
